var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"flat":"","icon":"","color":"grey"}},[_c('v-icon',{on:{"click":_vm.callReload}},[_vm._v("loop")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }